import { LogLevel } from "@azure/msal-browser";

// Check if we're in development mode to conditionally set up auth
const isDevelopment = process.env.NODE_ENV === 'development';
const skipAuth = isDevelopment && process.env.REACT_APP_SKIP_AUTH === 'true';

// Get the base URL for redirects
const baseUrl = isDevelopment ? 'http://localhost:3002' : window.location.origin;

console.log("Auth config loading with environment variables:");
console.log("- NODE_ENV:", process.env.NODE_ENV);
console.log("- REACT_APP_SKIP_AUTH:", process.env.REACT_APP_SKIP_AUTH);
console.log("- Skip Auth Active:", skipAuth);
console.log("- Base URL for redirects:", baseUrl);

// Default client ID and tenant ID for when actual values aren't available
const DEFAULT_CLIENT_ID = "6fadcd9f-33de-4956-bdb5-455ea84eae14";
const DEFAULT_TENANT_ID = "9b74c974-eace-41b2-9072-6f404b5cccfc";
const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || DEFAULT_CLIENT_ID;
const TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || DEFAULT_TENANT_ID;

// Azure AD / Microsoft Entra ID configuration
export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: `${baseUrl}/dashboard`,
    postLogoutRedirectUri: `${baseUrl}`,
    navigateToLoginRequestUrl: true, // Set to true to navigate back to the original request URL
  },
  cache: {
    cacheLocation: "localStorage", // Changed from sessionStorage to maintain state across tabs/sessions
    storeAuthStateInCookie: true, // Set to true to avoid the hash_empty_error on redirect
  },
  system: {
    allowRedirectInIframe: true, // Required for popup/redirect in same window
    iframeHashTimeout: 10000, // Extend timeout for hash processing
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error("MSAL:", message);
            return;
          case LogLevel.Info:
            console.info("MSAL:", message);
            return;
          case LogLevel.Verbose:
            console.debug("MSAL:", message);
            return;
          case LogLevel.Warning:
            console.warn("MSAL:", message);
            return;
          default:
            return;
        }
      },
      logLevel: isDevelopment ? LogLevel.Verbose : LogLevel.Error,
      piiLoggingEnabled: false
    },
  },
};

// Permission scopes
//
// No `prompt` here on purpose: forcing "select_account" made Entra show the
// account picker on every single sign-in, defeating silent SSO. Omitting it
// lets Microsoft reuse an existing session when one is valid.
export const loginRequest = {
  scopes: ["openid", "profile", "offline_access"],
};

// Optional additional scopes for API access
export const tokenRequest = {
  scopes: [`api://${CLIENT_ID}/access_as_user`],
};
